// extracted by mini-css-extract-plugin
export var badge = "business-partner-tile-module--badge--df21e";
export var benefitLabelWrapper = "business-partner-tile-module--benefit-label-wrapper--e4120";
export var blurred = "business-partner-tile-module--blurred--a1ac3";
export var businessPartnerTile = "business-partner-tile-module--business-partner-tile--2704b";
export var codeText = "business-partner-tile-module--code-text--a003d";
export var disabled = "business-partner-tile-module--disabled--c3bbe";
export var highlight = "business-partner-tile-module--highlight--42cac";
export var labelText = "business-partner-tile-module--label-text--d0209";
export var logo = "business-partner-tile-module--logo--d49c6";
export var notHovered = "business-partner-tile-module--not-hovered--eb857";